import React from 'react';
import { motion } from 'framer-motion';
const points = [{
  emoji: '💔',
  text: 'Piensas demasiado en una persona'
}, {
  emoji: '💭',
  text: 'Revisas el celular esperando un mensaje'
}, {
  emoji: '😔',
  text: 'Sientes ansiedad cuando alguien se aleja'
}, {
  emoji: '🧠',
  text: 'Tu mente no descansa'
}, {
  emoji: '😞',
  text: 'Has perdido tranquilidad, enfoque y motivación'
}];
export function PainPoints() {
  return <section className="py-24 bg-teal-950" data-id="element-123">
      <div className="max-w-3xl mx-auto px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl mb-4 text-cream" data-id="element-126">
            Tal vez llevas tiempo{' '}
            <span className="italic text-terracotta" data-id="element-127">sintiéndote así…</span>
          </h2>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-128">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 p-4 rounded-2xl bg-teal-900 shadow-sm border border-cream/10" data-id="element-129">
              <span className="text-2xl" data-id="element-130">{point.emoji}</span>
              <p className="text-lg text-cream/90" data-id="element-131">{point.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center space-y-6 text-lg text-cream/70" data-id="element-132">
          <p data-id="element-133">Y aunque intentas seguir adelante…</p>
          <p className="font-serif text-2xl text-cream" data-id="element-134">
            hay algo dentro de ti que todavía no puede soltar.
          </p>
          <p data-id="element-135">
            Muchas personas sonríen por fuera…
            <br data-id="element-136" />
            pero por dentro viven cansadas emocionalmente.
          </p>
        </motion.div>
      </div>
    </section>;
}